/** Shared bits for the board-track games (Chutes & Ladders, Candy Path). */
import type { Seat } from '@campfire/engine';

export const SEAT_COLORS = ['#e5484d', '#3b82f6', '#22c55e', '#f5c518', '#a855f7', '#fb923c'] as const;
export const seatColor = (s: Seat): string => SEAT_COLORS[s % SEAT_COLORS.length] as string;

const NS = 'http://www.w3.org/2000/svg';
type Attrs = Record<string, string | number | undefined>;

/** Minimal SVG hyperscript. */
export function svg(tag: string, attrs: Attrs = {}, ...children: (SVGElement | string | null | false)[]): SVGElement {
  const el = document.createElementNS(NS, tag);
  for (const [k, v] of Object.entries(attrs)) if (v !== undefined) el.setAttribute(k, String(v));
  for (const c of children) {
    if (c === null || c === false) continue;
    el.append(typeof c === 'string' ? document.createTextNode(c) : c);
  }
  return el;
}

/** Offsets so several tokens on one square stay visible (up to six). */
export const TOKEN_SLOTS: readonly (readonly [number, number])[] = [
  [-0.22, -0.2], [0.22, -0.2], [-0.22, 0.22], [0.22, 0.22], [0, 0], [0, -0.3],
];

/** A pawn marker whose outline differs per seat (circle, square, triangle, diamond), so colour is never the only cue. */
export function pawnShape(seat: Seat, x: number, y: number, r: number, attrs: Attrs = {}): SVGElement {
  const common = { fill: seatColor(seat), ...attrs };
  switch (seat % 4) {
    case 0: return svg('circle', { cx: x, cy: y, r, ...common });
    case 1: return svg('rect', { x: x - r * 0.9, y: y - r * 0.9, width: r * 1.8, height: r * 1.8, rx: 2, ...common });
    case 2: return svg('polygon', { points: `${x},${y - r * 1.15} ${x + r * 1.1},${y + r * 0.85} ${x - r * 1.1},${y + r * 0.85}`, ...common });
    default: return svg('polygon', { points: `${x},${y - r * 1.2} ${x + r * 1.2},${y} ${x},${y + r * 1.2} ${x - r * 1.2},${y}`, ...common });
  }
}
